<template>
    <div :class="outerWrapperClass">
        <form :class="`${formClass}`"
            autocomplete="off"
            @submit.prevent="submit">
            <input
                id="myInput"
                :class="`${inputClass}`"
                @click.prevent.stop="onInputClick"
                @input="onInput"
                @keydown="onKeyDown"
                :value="value"
                type="text"
                name="search-help"
                :placeholder="placeholder"
            />
            <slot name="afterInputSlot" />
            <i :class="`${iconClass} icon icon-close`"
                @click="onResetClick">
            </i>
        </form>


        <div v-if="(isAsync && isOpened) && (isError || isLoading)"
            class="searchbox__results searchbox__results--active"
            :class="resultsClass">

            <div v-if="isLoading" class="searchbox__result-item">
                <div class="searchbox__result-item-category">
                    {{$t('UI.searchBox.loading')}}
                </div>
            </div>

            <div v-if="isError" class="searchbox__result-item">
                <div class="searchbox__result-item-category">
                    {{error ? error : $t('UI.searchBox.searchError')}}
                </div>
            </div>
        </div>

        <SearchAsyncSuggestions
            v-else-if="(isAsync && isOpened)"
            :options="options"
            :focus-item-index="focusItemIndex"
            :select-item="selectItem"
            :isLoading="isLoading"
            :isError="isError"
            :className="resultsClass"
        />
    </div>
</template>


<script>
import debounce from 'lodash.debounce';
import SearchAsyncSuggestions from './SearchAsyncSuggestions';

export default {
    components: {
        SearchAsyncSuggestions
    },
    props: {
        defaultFocusIndex: Number,
        initValue: {},
        items: Array,
        isAsync: Boolean,
        filteredItems: Array,
        isLoading: Boolean,
        isError: Boolean,
        error: String,
        placeholder: String,
        showBack: {type: Boolean, default: false},
        outerWrapperClassname: String,
        classNamePrefix: String,
        wrapperClassname: {type: String, default: ''},
        formClass: String,
        inputClass: String,
        iconClass: String,
        resultsClass: String
    },
    data() {
        const defaultFocusValue = !isNaN(this.defaultFocusIndex) ? this.defaultFocusIndex : -1;
        return {
            isOpened: false,
            defaultFocusValue: defaultFocusValue,
            focusItemIndex: defaultFocusValue
        }
    },
    computed: {
        options: function () {
            if (!this.isAsync) {
                return this.items.filter(item => {
                    return item.substr(0, this.value.length).toUpperCase() == this.value.toUpperCase();
                });
            } else {
                 return this.filteredItems;
            }
        },
        value: {
            set(val) {
                this.$emit('input', val);
            },
            get() {
                return this.initValue !== undefined ? this.initValue : "";
            }
        },
        outerWrapperClass: function () {
            let className = '';
            console.log('this.outerWrapperClassname: ', this.outerWrapperClassname);
            if (this.outerWrapperClassname) {
                className = this.outerWrapperClassname;
                if (this.isOpened) {
                    className += ` ${this.outerWrapperClassname}--active`;
                }
            }
            console.log('className:: ', className);
            return className;
        }
    },
    methods: {
        debounceSearch: debounce(function(val) {
            this.isOpened = true;
            this.$emit('getItems', val);
        }, 200),
        submit() {
            this.isOpened = false;
            if (this.focusItemIndex > -1) {
                let item = this.options[this.focusItemIndex];
                this.$emit('selectItem', item);
            } else {
                let value = this.value;
                this.$emit('submit', value);
            }
            this.focusItemIndex = this.defaultFocusValue;
        },
        onResetClick() {
            this.value = '';
            this.$emit('reset');
        },
        onInputClick() {
            this.isOpened = true;
            this.$emit('open', this.value);

            this.$forceUpdate();
            document.addEventListener('click', this.close);
        },
        onInput(e) {
            const val = e.target.value;
            this.value = val;
            this.focusItemIndex = this.defaultFocusValue;

            if (this.isAsync) {
                this.debounceSearch(val);
            } else {
                this.isOpened = true;
            }

            this.$forceUpdate();
            document.addEventListener('click', this.close);
        },
        selectItem(item) {
            this.isOpened = false;
            this.value = item.text;
            this.focusItemIndex = this.defaultFocusValue;
            this.$emit('selectItem', item);
        },
        onKeyDown(e) {
            if (this.isOpened === true && this.options.length > 0) {
                //down
                if(e.keyCode === 40) {
                    if (this.focusItemIndex < this.options.length) {
                        this.focusItemIndex++;
                    }
                    if (this.focusItemIndex === this.options.length) {
                        this.focusItemIndex = 0;
                    }

                //up
                } else if(e.keyCode == 38) {
                    if (this.focusItemIndex >= 0) {
                        this.focusItemIndex--;
                    }
                    if (this.focusItemIndex === -1) {
                        this.focusItemIndex = this.options.length - 1;
                    }

                //enter
                } else if(e.keyCode == 13) {
                    if (this.focusItemIndex !== -1) {
                        this.value = this.options[this.focusItemIndex];
                    }

                //esc
                } else if (e.keyCode == 27) {
                    this.close();
                }

            }
        },
        close() {
            this.isOpened = false;
            this.activeItem = false;
            this.focusItemIndex = this.defaultFocusValue;
            document.removeEventListener('click', this.close);
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', this.close);
    }
}
</script>


<style scoped>
</style>
